export const PageRoutes = {
  account: "/v3/dashboard/account",
  addAddress: "/v3/dashboard/account/add-address",
  addPayment: "/v3/dashboard/account/add-payment",
  addresses: "/v3/dashboard/account/addresses",
  changePassword: "/v3/dashboard/account/change-password",
  checkout: (cartId: string, appId: string) => `/v3/${cartId}/${appId}`,
  editAddress: (addrId: string) =>
    `/v3/dashboard/account/edit-address/${addrId}`,
  exchange: "/v3/dashboard/exchange",
  exchangeDetails: (exchangeId: string) =>
    `/v3/dashboard/exchange/${exchangeId}`,
  machines: "/v3/dashboard/machines",
  orderDetails: (orderId: string) => `/v3/dashboard/orders/${orderId}`,
  orders: "/v3/dashboard/orders",
  payments: "/v3/dashboard/account/payments",
  signIn: "/v3/sign-in",
  signUp: "/v3/sign-up",
  status: (orderId: string, appId: string) => `/v3/status/${orderId}/${appId}`,
  subscriptionAddPayment: (subId: string) =>
    `/v3/dashboard/subscriptions/${subId}/payments/add-payment`,
  subscriptionAddresses: (subId: string) =>
    `/v3/dashboard/subscriptions/${subId}/addresses`,
  subscriptionDetail: (subId: string) => `/v3/dashboard/subscriptions/${subId}`,
  subscriptionEditAddress: (subId: string, addrId: string) =>
    `/v3/dashboard/subscriptions/${subId}/addresses/${addrId}`,
  subscriptionList: "/v3/dashboard/subscriptions",
  subscriptionPayments: (subId: string) =>
    `/v3/dashboard/subscriptions/${subId}/payments`,
  taxExemption: "/v3/dashboard/tax-exemption",
  taxExemptionRequest: "/v3/dashboard/tax-exemption-request",
  updatePassword: "/v3/update-password",
};
